if (!customElements.get('product-shipping-info')) {
  class ProductShippingInfo extends HTMLElement {
    connectedCallback() {
      this.#updateDispatchDate();
    }

    #updateDispatchDate() {
      const dateEl = this.querySelector('.product-shipping-info__date');
      if (!dateEl) return;

      const offset = parseInt(this.dataset.dispatchDaysOffset ?? '1', 10);
      const daysToAdd = Number.isFinite(offset) ? Math.max(0, offset) : 1;
      const dispatchDate = new Date();
      dispatchDate.setHours(0, 0, 0, 0);
      dispatchDate.setDate(dispatchDate.getDate() + daysToAdd);

      const locale = document.documentElement.lang?.replace('_', '-') || undefined;
      const formatter = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      });

      dateEl.textContent = formatter.format(dispatchDate);
    }
  }

  customElements.define('product-shipping-info', ProductShippingInfo);
}
